export default {
  header: {
    1: [
      {
        title:
          '1. Ceritakan apa yang memotivasi Anda untuk melamar sebagai Fasilitator dalam program Sekolah Penggerak?',
        contentsId: [21, 22, 23],
      },
      {
        title:
          '2. Ceritakan pengalaman Anda mengatasi permasalahan sulit atau kompleks saat menjalani peran sebagai Pembimbing/Pelatih/Mentor/Pendamping Sekolah/Pendamping Kepala Sekolah/Guru/Pengawas/Penilik.',
        contentsId: [24, 25, 26, 27],
      },
      {
        title:
          '3. Ceritakan pengalaman Anda sebagai seorang pembimbing, pendamping, atau pelatih dalam meyakinkan orang lain untuk mau berubah (misalnya merubah perilaku, cara pandang, dan sebagainya)',
        contentsId: [28, 29, 30, 31],
      },
      {
        title:
          '4. Ceritakan pengalaman Anda melakukan bimbingan, pendampingan, ataupun pelatihan kepada orang lain (kepala sekolah, pengawas, penilik, guru)',
        contentsId: [32, 33, 34, 35],
      },
      {
        title:
          '5. Ceritakan pengalaman Anda meningkatkan kapabilitas diri sebagai seorang Pembimbing/Pelatih/Mentor/Pendamping Sekolah/Pendamping Kepala Sekolah/Guru/Pengawas/Penilik',
        contentsId: [36, 37, 38, 39],
      },
      {
        title:
          '6. Berinteraksi dengan orang lain terkadang dapat menjadi sebuah tantangan. Ceritakan kesulitan yang Anda alami saat bekerja sama dengan pihak lain (misalnya pengawas, pimpinan di sekolah, lembaga pemerintahan, masyarakat, dan lainnya) guna menimbulkan kesadaran dan kesediaan agar mereka berkomitmen membantu Anda mencapai tujuan bersama',
        contentsId: [36, 37, 38, 39],
      },
      {
        title:
          '7. Ceritakan pengalaman Anda mengedepankan profesionalitas sebagai Pembimbing/Pelatih/Mentor/Pendamping Sekolah/Pendamping Kepala Sekolah/Guru/Pengawas/Penilik dalam mendampingi sekolah/guru secara adil dan setara',
        contentsId: [36, 37, 38, 39],
      },
    ],
  },
};
